/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function SnapchatLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M18.52262,188.68274S72,163.9473,72,80a56,56,0,0,1,112,0c0,83.94728,53.47772,108.6824,53.47772,108.6824-9.25514,8.68693-28.93167,3.38673-40.13691,9.55547-11.03868,6.077-17.07266,25.58078-29.56764,28.77765C155.6908,230.10684,141.04586,216,128,216s-27.6905,14.10686-39.77275,11.01563C75.73218,223.81879,69.69808,204.315,58.65931,198.238,47.45415,192.06928,27.77771,197.36958,18.52262,188.68274Z"
        opacity={0.2}
      />
      <Path
        d="M18.52262,188.68274S72,163.9473,72,80a56,56,0,0,1,112,0c0,83.94728,53.47772,108.6824,53.47772,108.6824-9.25514,8.68693-28.93167,3.38673-40.13691,9.55547-11.03868,6.077-17.07266,25.58078-29.56764,28.77765C155.6908,230.10684,141.04586,216,128,216s-27.6905,14.10686-39.77275,11.01563C75.73218,223.81879,69.69808,204.315,58.65931,198.238,47.45415,192.06928,27.77771,197.36958,18.52262,188.68274Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={189.3256}
        y1={122.66978}
        x2={216}
        y2={112.00002}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
      <Line
        x1={66.67601}
        y1={122.67043}
        x2={40}
        y2={112.00002}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={16}
      />
    </Svg>
  );
}

export default SnapchatLogo;
